import { render, staticRenderFns } from "./FavoriteAddresses.vue?vue&type=template&id=5298132b&"
import script from "./FavoriteAddresses.vue?vue&type=script&lang=js&"
export * from "./FavoriteAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports